"use strict";
// import { LogMenu } from "../lib/menu";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
  LogLevel[(LogLevel["off"] = 0)] = "off";
  LogLevel[(LogLevel["error"] = 1)] = "error";
  LogLevel[(LogLevel["warn"] = 2)] = "warn";
  LogLevel[(LogLevel["info"] = 3)] = "info";
  LogLevel[(LogLevel["debug"] = 4)] = "debug";
  LogLevel[(LogLevel["trace"] = 5)] = "trace";
})((LogLevel = exports.LogLevel || (exports.LogLevel = {})));
//# sourceMappingURL=types.js.map
